export default __webpack_public_path__ + "static/media/archi_view1_a.85688c0e.webp";